import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { RefundPolicyService } from 'src/app/features/restaurants/services/Cancellation.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import Swal from 'sweetalert2';


export interface DialogData {
  amount: number,
  restaurantId: number
}

@Component({
  selector: 'app-show-policy',
  templateUrl: './show-policy.component.html'
})
export class ShowPolicyComponent extends DirtyComponent implements OnInit {
  override formGroup!: FormGroup;
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data.amount ? true : false;
  constructor(override dialogRef: MatDialogRef<ShowPolicyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder,
     translate: TranslateService, private service: RefundPolicyService) {
      super(translate);
      }

  ngOnInit(): void {
    this.buildForm();
    if (this.isUpdate) {
      this.bindDataToUpdate();
    }
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      amount: [0, [
        Validators.required,
        Validators.maxLength(20),
        Validators.max(100),
        Validators.pattern(Patterns.float)
      ]],
      restaurantId: this.data.restaurantId
    });
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  bindDataToUpdate() {
    this.formGroup.patchValue({
      amount: this.data.amount,
      restaurantId: this.data.restaurantId
    });
  }


  saveRecord(openNew: boolean = false) {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      let data = {
        amount: this.formGroup.controls['amount'].value,
        restaurantId: this.data.restaurantId
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.amount =  this.formGroup.controls['amount'].value;
        data.restaurantId = this.data.restaurantId;
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.EditNoShowPolicy(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        if (openNew) {
          this.formGroup.reset();
        } else {
          this.dialogRef.close(true);
        }
        this.service.refreshList.next(true);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }


}
